import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../context/LanguageContext';

const TeamExpertiseSection = () => {
  const { t } = useTranslation();
  const { language } = useLanguage();

  return (
    <section className="section" style={{ 
      backgroundColor: 'white',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Decorative elements */}
      <div style={{
        position: 'absolute',
        top: '20%',
        left: '5%',
        width: '200px',
        height: '200px',
        borderRadius: '43% 57% 70% 30% / 30% 36% 64% 70%',
        background: 'linear-gradient(45deg, rgba(255, 107, 0, 0.05) 0%, rgba(255, 215, 0, 0.05) 100%)',
        animation: 'blob-animation 25s linear infinite',
        zIndex: 1
      }}></div>
      
      <div style={{
        position: 'absolute',
        bottom: '10%',
        right: '5%',
        width: '300px',
        height: '300px',
        borderRadius: '70% 30% 30% 70% / 60% 40% 60% 40%',
        background: 'linear-gradient(45deg, rgba(255, 107, 0, 0.05) 0%, rgba(255, 215, 0, 0.05) 100%)',
        animation: 'blob-animation-reverse 20s linear infinite',
        zIndex: 1
      }}></div>
      
      <div className="container" style={{ position: 'relative', zIndex: 2 }}>
        <div className="grid" style={{ 
          display: 'grid',
          gridTemplateColumns: 'repeat(12, 1fr)', 
          gap: '3rem',
          alignItems: 'center'
        }}>
          <div className="col-span-5 md-col-span-12 fade-in">
            <div className="image-container" style={{ 
              position: 'relative',
              borderRadius: 'var(--radius-lg)',
              overflow: 'hidden',
              boxShadow: 'var(--shadow-lg)',
              height: '450px'
            }}>
              {/* Team expertise image placeholder */}
              <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='600' height='600' viewBox='0 0 600 600'%3E%3Crect width='600' height='600' fill='%23f3f4f6'/%3E%3Ccircle cx='200' cy='150' r='50' fill='%23d1d5db'/%3E%3Cpath d='M120,300 C120,240 170,210 200,210 C230,210 280,240 280,300' fill='%23d1d5db'/%3E%3Ccircle cx='400' cy='150' r='50' fill='%23d1d5db'/%3E%3Cpath d='M320,300 C320,240 370,210 400,210 C430,210 480,240 480,300' fill='%23d1d5db'/%3E%3Crect x='150' y='350' width='300' height='150' rx='10' fill='%23FF6B00' fill-opacity='0.1' stroke='%23FF6B00' stroke-opacity='0.3' stroke-width='2'/%3E%3Ctext x='300' y='425' text-anchor='middle' font-family='Arial' font-size='24' fill='%23333333'%3E20+ Years Experience%3C/text%3E%3C/svg%3E")`,
                backgroundSize: 'cover',
                backgroundPosition: 'center'
              }}></div>
              
              {/* Expertise badges */}
              <div style={{
                position: 'absolute',
                top: '20px',
                right: '20px',
                backgroundColor: 'rgba(255, 107, 0, 0.9)',
                color: 'white',
                padding: '0.5rem 1rem',
                borderRadius: 'var(--radius-full)',
                fontSize: '0.875rem',
                fontWeight: '600',
                boxShadow: 'var(--shadow-md)'
              }}>
                {language === 'fr' ? 'Expertise Panametrics' : 
                 language === 'ar' ? 'خبرة Panametrics' : 
                 'Panametrics Expertise'}
              </div>
              
              <div style={{
                position: 'absolute',
                top: '70px',
                right: '20px',
                backgroundColor: 'rgba(255, 215, 0, 0.9)',
                color: 'var(--assco-gray-900)',
                padding: '0.5rem 1rem',
                borderRadius: 'var(--radius-full)',
                fontSize: '0.875rem',
                fontWeight: '600',
                boxShadow: 'var(--shadow-md)'
              }}>
                            {language === 'fr' ? 'Équipe Certifiée' :
             language === 'ar' ? 'فريق معتمد' :
             'Certified Team'}
              </div>
            </div>
          </div>
          
          <div className="col-span-7 md-col-span-12 fade-in" style={{ animationDelay: '0.3s' }}>
            <h2 style={{ 
              fontSize: '2.5rem', 
              marginBottom: '1.5rem',
              position: 'relative',
              paddingBottom: '1rem',
              color: 'var(--assco-gray-800)'
            }}>
              {t('about.team.title')}
              <span style={{
                position: 'absolute',
                bottom: 0,
                left: 0,
                width: '80px',
                height: '4px',
                backgroundColor: 'var(--assco-orange)',
                borderRadius: '2px'
              }}></span>
            </h2>
            
            <p className="text-gray-700" style={{ 
              fontSize: '1.125rem', 
              lineHeight: '1.7',
              marginBottom: '1.5rem',
              color: 'var(--assco-gray-600)'
            }}>
              {t('about.team.content')}
            </p>
            
            <p className="text-gray-700" style={{ 
              fontSize: '1.125rem', 
              lineHeight: '1.7',
              marginBottom: '1.5rem',
              color: 'var(--assco-gray-600)'
            }}>
              {language === 'fr' 
                ? 'En 2017, Allaoua a élargi son rôle en tant qu\'ingénieur de service de terrain chez Baker Hughes, fournissant un soutien technique et aidant aux ventes. Avec 14 années d\'expérience sur le terrain, Allaoua et l\'équipe ont suivi le travail de Panametrics, admirant profondément leur engagement envers l\'excellence et la satisfaction du client.'
                : language === 'ar'
                ? 'في عام 2017، وسع علاوة دوره كمهندس خدمة ميداني لدى Baker Hughes، حيث قدم الدعم الفني وساعد في المبيعات. مع 14 عاماً من الخبرة في هذا المجال، تابع علاوة وفريقه عمل Panametrics، معجبين بشدة بالتزامهم بالتميز ورضا العملاء.'
                : 'In 2017, Allaoua expanded his role as a Field Service Engineer with Baker Hughes, providing technical support and assisting in sales. With 14 years of experience in the field, Allaoua and the team have been following Panametrics\' work, deeply admiring their commitment to excellence and customer satisfaction.'}
            </p>
            
            <div className="expertise-timeline fade-in" style={{ 
              marginTop: '2.5rem',
              position: 'relative',
              paddingLeft: language === 'ar' ? 0 : '30px',
              paddingRight: language === 'ar' ? '30px' : 0
            }}>
              {/* Timeline line */}
              <div style={{
                position: 'absolute',
                top: 0,
                bottom: 0,
                left: language === 'ar' ? 'auto' : 0,
                right: language === 'ar' ? 0 : 'auto',
                width: '2px',
                backgroundColor: 'var(--assco-gray-200)',
                zIndex: 1
              }}></div>
              
              {/* Timeline items */}
              <div className="timeline-item" style={{
                position: 'relative',
                marginBottom: '1.5rem',
                paddingLeft: language === 'ar' ? 0 : '2rem',
                paddingRight: language === 'ar' ? '2rem' : 0
              }}>
                <div style={{
                  position: 'absolute',
                  top: '0',
                  left: language === 'ar' ? 'auto' : '-30px',
                  right: language === 'ar' ? '-30px' : 'auto',
                  width: '16px',
                  height: '16px',
                  borderRadius: '50%',
                  backgroundColor: 'var(--assco-orange)',
                  border: '3px solid var(--assco-gray-100)',
                  boxShadow: 'var(--shadow-md)',
                  zIndex: 2
                }}></div>
                
                <h3 style={{ 
                  fontSize: '1.25rem',
                  marginBottom: '0.5rem',
                  color: 'var(--assco-gray-900)'
                }}>
                  {language === 'fr' ? 'Mai 2025' : language === 'ar' ? 'مايو 2025' : 'May 2025'}
                </h3>
                <p style={{ 
                  fontSize: '1rem',
                  color: 'var(--assco-gray-700)',
                  marginBottom: '0.5rem'
                }}>
                  <strong>
                    {language === 'fr' ? 'Fondation d\'ASSCO' : 
                     language === 'ar' ? 'تأسيس ASSCO' : 
                     'ASSCO Foundation'}
                  </strong>
                </p>
                <p style={{ 
                  fontSize: '0.9375rem',
                  color: 'var(--assco-gray-600)',
                  lineHeight: '1.6'
                }}>
                  {language === 'fr' ? 'Création d\'ASSCO pour fournir des solutions d\'instrumentation pour le secteur Pétrole et gaz de premier ordre en Algérie et Tunisie.' : 
                   language === 'ar' ? 'تأسيس ASSCO لتوفير حلول أجهزة لقطاع النفط والغاز من الدرجة الأولى في الجزائر وتونس.' : 
                   'Establishment of ASSCO to provide premier instrumentation solutions for the Oil and Gas sector in Algeria and Tunisia.'}
                </p>
              </div>
              
              <div className="timeline-item" style={{
                position: 'relative',
                marginBottom: '1.5rem',
                paddingLeft: language === 'ar' ? 0 : '2rem',
                paddingRight: language === 'ar' ? '2rem' : 0
              }}>
                <div style={{
                  position: 'absolute',
                  top: '0',
                  left: language === 'ar' ? 'auto' : '-30px',
                  right: language === 'ar' ? '-30px' : 'auto',
                  width: '16px',
                  height: '16px',
                  borderRadius: '50%',
                  backgroundColor: 'var(--assco-orange)',
                  border: '3px solid var(--assco-gray-100)',
                  boxShadow: 'var(--shadow-md)',
                  zIndex: 2
                }}></div>
                
                <h3 style={{ 
                  fontSize: '1.25rem',
                  marginBottom: '0.5rem',
                  color: 'var(--assco-gray-900)'
                }}>
                  {language === 'fr' ? '2017-Mars 2025' : language === 'ar' ? '2017-مارس 2025' : '2017-March 2025'}
                </h3>
                <p style={{ 
                  fontSize: '1rem',
                  color: 'var(--assco-gray-700)',
                  marginBottom: '0.5rem'
                }}>
                  <strong>
                    {language === 'fr' ? 'Ingénieur de Service chez Baker Hughes' : 
                     language === 'ar' ? 'مهندس خدمة في Baker Hughes' : 
                     'Service Engineer at Baker Hughes'}
                  </strong>
                </p>
                <p style={{ 
                  fontSize: '0.9375rem',
                  color: 'var(--assco-gray-600)',
                  lineHeight: '1.6'
                }}>
                  {language === 'fr' ? 'Spécialisation dans les instruments de mesure de débit, de gaz et d\'humidité.' : 
                   language === 'ar' ? 'التخصص في أجهزة قياس التدفق والغاز والرطوبة.' : 
                   'Specialization in flow, gas, and moisture measurement instruments.'}
                </p>
              </div>
              
              <div className="timeline-item" style={{
                position: 'relative',
                marginBottom: '1.5rem',
                paddingLeft: language === 'ar' ? 0 : '2rem',
                paddingRight: language === 'ar' ? '2rem' : 0
              }}>
                <div style={{
                  position: 'absolute',
                  top: '0',
                  left: language === 'ar' ? 'auto' : '-30px',
                  right: language === 'ar' ? '-30px' : 'auto',
                  width: '16px',
                  height: '16px',
                  borderRadius: '50%',
                  backgroundColor: 'var(--assco-orange)',
                  border: '3px solid var(--assco-gray-100)',
                  boxShadow: 'var(--shadow-md)',
                  zIndex: 2
                }}></div>
                
                <h3 style={{ 
                  fontSize: '1.25rem',
                  marginBottom: '0.5rem',
                  color: 'var(--assco-gray-900)'
                }}>
                  2010-2017
                </h3>
                <p style={{ 
                  fontSize: '1rem',
                  color: 'var(--assco-gray-700)',
                  marginBottom: '0.5rem'
                }}>
                  <strong>
                    {language === 'fr' ? 'GE Oil & Gas, Ingénieur Service' : 
                     language === 'ar' ? 'GE Oil & Gas، مهندس خدمة' : 
                     'GE Oil & Gas, Service Engineer'}
                  </strong>
                </p>
                <p style={{ 
                  fontSize: '0.9375rem',
                  color: 'var(--assco-gray-600)',
                  lineHeight: '1.6'
                }}>
                  {language === 'fr' ? 'Couvrant l\'Afrique du Nord pour les produits GE Sensing.' : 
                   language === 'ar' ? 'تغطية شمال إفريقيا لمنتجات GE Sensing.' : 
                   'Covering North Africa for GE Sensing products.'}
                </p>
              </div>
              
              <div className="timeline-item" style={{
                position: 'relative',
                marginBottom: '1.5rem',
                paddingLeft: language === 'ar' ? 0 : '2rem',
                paddingRight: language === 'ar' ? '2rem' : 0
              }}>
                <div style={{
                  position: 'absolute',
                  top: '0',
                  left: language === 'ar' ? 'auto' : '-30px',
                  right: language === 'ar' ? '-30px' : 'auto',
                  width: '16px',
                  height: '16px',
                  borderRadius: '50%',
                  backgroundColor: 'var(--assco-orange)',
                  border: '3px solid var(--assco-gray-100)',
                  boxShadow: 'var(--shadow-md)',
                  zIndex: 2
                }}></div>
                
                <h3 style={{ 
                  fontSize: '1.25rem',
                  marginBottom: '0.5rem',
                  color: 'var(--assco-gray-900)'
                }}>
                  2008-2010
                </h3>
                <p style={{ 
                  fontSize: '1rem',
                  color: 'var(--assco-gray-700)',
                  marginBottom: '0.5rem'
                }}>
                  <strong>
                    {language === 'fr' ? 'Sous-traitant pour GE Oil & Gas' : 
                     language === 'ar' ? 'مقاول من الباطن لـ GE Oil & Gas' : 
                     'Contractor for GE Oil & Gas'}
                  </strong>
                </p>
                <p style={{ 
                  fontSize: '0.9375rem',
                  color: 'var(--assco-gray-600)',
                  lineHeight: '1.6'
                }}>
                  {language === 'fr' ? 'Travaillé en tant que sous-traitant pour GE Oil & Gas.' : 
                   language === 'ar' ? 'عمل كمقاول من الباطن لـ GE Oil & Gas.' : 
                   'Worked as a contractor for GE Oil & Gas.'}
                </p>
              </div>
              
              <div className="timeline-item" style={{
                position: 'relative',
                paddingLeft: language === 'ar' ? 0 : '2rem',
                paddingRight: language === 'ar' ? '2rem' : 0
              }}>
                <div style={{
                  position: 'absolute',
                  top: '0',
                  left: language === 'ar' ? 'auto' : '-30px',
                  right: language === 'ar' ? '-30px' : 'auto',
                  width: '16px',
                  height: '16px',
                  borderRadius: '50%',
                  backgroundColor: 'var(--assco-orange)',
                  border: '3px solid var(--assco-gray-100)',
                  boxShadow: 'var(--shadow-md)',
                  zIndex: 2
                }}></div>
                
                <h3 style={{ 
                  fontSize: '1.25rem',
                  marginBottom: '0.5rem',
                  color: 'var(--assco-gray-900)'
                }}>
                  1991-2008
                </h3>
                <p style={{ 
                  fontSize: '1rem',
                  color: 'var(--assco-gray-700)',
                  marginBottom: '0.5rem'
                }}>
                  <strong>
                    {language === 'fr' ? 'Sonatrach Division Production' : 
                     language === 'ar' ? 'سوناطراك قسم الإنتاج' : 
                     'Sonatrach Production Division'}
                  </strong>
                </p>
                <p style={{ 
                  fontSize: '0.9375rem',
                  color: 'var(--assco-gray-600)',
                  lineHeight: '1.6'
                }}>
                  {language === 'fr' ? 'Expérience dans la division production de Sonatrach.' : 
                   language === 'ar' ? 'خبرة في قسم الإنتاج في سوناطراك.' : 
                   'Experience in Sonatrach production division.'}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <style jsx>{`
        @keyframes blob-animation-reverse {
          0% {
            transform: translate(0%, 0%) rotate(0deg);
          }
          25% {
            transform: translate(-5%, -5%) rotate(-90deg);
          }
          50% {
            transform: translate(0%, -10%) rotate(-180deg);
          }
          75% {
            transform: translate(5%, -5%) rotate(-270deg);
          }
          100% {
            transform: translate(0%, 0%) rotate(-360deg);
          }
        }
      `}</style>
    </section>
  );
};

export default TeamExpertiseSection;
